/*
 * Mutations
 */
export const ORDER_SET_DEFAULT = 'order/update/setDefault';
export const ORDER_SET_STATE = 'order/update/setState';
export const ORDER_SET_DRAFT_ORDER = 'order/update/draftOrder';
export const ORDER_SET_EDIT_HISTORY = 'order/update/editHistory';
export const ORDER_SET_ID = 'order/update/orderId';
export const ORDER_SET_LOADING = 'order/update/isLoading';
export const ORDER_SET_D365 = 'order/update/d365';
export const ORDER_SET_D365_ERROR = 'order/update/d365/error';
export const ORDER_SET_MAX_ELIGIBLE_AMOUNT = 'order/update/maxEligibleAmount';
export const ORDER_SET_NOTE = 'order/update/note';
export const ORDER_SET_ORDER = 'order/update/set';
export const ORDER_SET_REGION = 'order/update/region';
export const ORDER_SET_HIDE_BUTTON = 'order/update/setHideButton';
//
export const ORDER_SET_DISCOUNT_CODE = 'order/update/discount/code';
export const ORDER_SET_DISCOUNT_FIXED = 'order/update/discount/fixed';
export const ORDER_SET_DISCOUNT_PERCENT = 'order/update/discount/percent';
export const ORDER_SET_DISCOUNT_TYPE = 'order/update/discount/type';
export const ORDER_SET_DISCOUNT_PRICE_RULE = 'order/update/discount/price-rule';
//
export const ORDER_SET_PAYMENT_LINE_ITEMS = 'order/update/payment/lineItems';
export const ORDER_SET_PAYMENT_REFUND = 'order/update/payment/refund';
export const ORDER_SET_PAYMENT_SUBTOTAL = 'order/update/payment/subtotal';
export const ORDER_SET_PAYMENT_TOTAL_TAX = 'order/update/payment/total/tax';
export const ORDER_SET_PAYMENT_TOTAL_PRICE = 'order/update/payment/total/price';
export const ORDER_SET_PRODUCTS_ADD = 'order/update/products/add';
export const ORDER_SET_PRODUCTS_INIT = 'order/update/products/init';
export const ORDER_SET_PRODUCTS_LOADING = 'order/update/products/isLoading';
export const ORDER_SET_PRODUCTS_QUANTITY = 'order/update/products/quantity';
export const ORDER_SET_PRODUCTS_REMOVE = 'order/update/products/remove';
export const ORDER_SET_PRODUCTS_SEARCH = 'order/update/products/search';
export const ORDER_SET_PRODUCTS_TOTAL = 'order/update/products/total';
export const ORDER_SET_PRODUCTS_VARIANT = 'order/update/products/variant';
export const ORDER_SET_SHIPPING_ADDRESS = 'order/update/address/shipping';
export const ORDER_SET_SHIPPING_CUSTOM_OPTIONS = 'order/update/shipping/custom/options';
export const ORDER_SET_SHIPPING_CUSTOM_SELECTED = 'order/update/shipping/custom/selected';
export const ORDER_SET_SHIPPING_CUSTOM_SELECTED_PRICE = 'order/update/shipping/custom/price';
export const ORDER_SET_SHIPPING_OPTIONS = 'order/update/shipping/options';
export const ORDER_SET_SHIPPING_SELECTED = 'order/update/shipping/selected';
export const ORDER_SET_SHIPPING_LINES = 'order/update/shipping/lines';
export const ORDER_SET_SHIPPING_ZONES = 'order/update/shipping/zones';

/*
 * Actions
 */
export const ERROR = 'error';
export const SUCCESS = 'success';
export const WARNING = 'warning';
//
export const ORDER_RESET = 'order/update/reset';
export const ORDER_DRAFT_SAVE = 'order/update/draft/save';
export const ORDER_CANCEL = 'order/update/cancel';
export const ORDER_DRAFT_CANCEL = 'order/update/draft/cancel';
export const ORDER_INIT = 'order/update/init';
export const ORDER_FETCH = 'order/update/fetch';
export const ORDER_D365_FETCH = 'order/update/fetch/d365';
export const ORDER_REFUND_PAYMENT = 'order/update/refund';
export const ORDER_UPDATE = 'order/update/update';
//
export const ORDER_DISCOUNT_APPLY_CODE = 'order/update/discount/apply/code';
export const ORDER_DISCOUNT_APPLY_FIXED = 'order/update/discount/apply/fixed';
export const ORDER_DISCOUNT_APPLY_PRICE_RULE = 'order/update/discount/apply/priceRule';
export const ORDER_DISCOUNT_APPLY_PERCENT = 'order/update/discount/apply/percent';
export const ORDER_DISCOUNT_INIT = 'order/update/discount/init';
export const ORDER_DISCOUNT_REMOVE_CODE = 'order/update/discount/remove/code';
export const ORDER_DISCOUNT_SHOPIFY_SEARCH = 'order/update/discount/shopify/search';
export const ORDER_PAYMENT_INIT = 'order/update/payment/init';
export const ORDER_PAYMENT_REFRESH = 'order/update/payment/refresh';
export const ORDER_PAYMENT_FETCH_TAXES = 'order/update/payment/taxes';
export const ORDER_PRODUCTS_ADD = 'order/update/products/add';
export const ORDER_PRODUCTS_INIT = 'order/update/products/init';
export const ORDER_PRODUCTS_REMOVE = 'order/update/products/remove';
export const ORDER_PRODUCTS_SEARCH = 'order/update/products/search';
export const ORDER_PRODUCTS_UPDATE_PRICE = 'order/update/products/update/price';
export const ORDER_PRODUCTS_UPDATE_QUANTITY = 'order/update/products/update/quantity';
export const ORDER_PRODUCTS_UPDATE_TOTALS = 'order/update/products/update/totals';
export const ORDER_PRODUCTS_UPDATE_VARIANT = 'order/update/products/update/variants';
export const ORDER_SHIPPING_APPLY_SELECTED = 'order/update/shipping/applySelected';
export const ORDER_SHIPPING_CUSTOM_SELECT = 'order/update/shipping/custom/select';
export const ORDER_SHIPPING_INIT = 'order/update/shipping/init';
export const ORDER_SHIPPING_RESET = 'order/update/shipping/reset';
export const ORDER_SHIPPING_SELECT = 'order/update/shipping/select';
export const ORDER_SHIPPING_FETCH_ZONES = 'order/update/shipping/fetch/zones';

/*
 * Getters
 */
export const ORDER_GET_CUSTOMER = 'order/update/customer';
export const ORDER_GET_DRAFT = 'order/update/draft';
export const ORDER_GET_DRAFT_KITSILANO = 'order/update/draft/kitsilano';
export const ORDER_GET_DISABLED_STATUS_AP = 'order/update/disabled/ap';
export const ORDER_GET_TAGS = 'order/update/tags';
export const ORDER_IS_LOADED = 'order/update/hasOrder';
//
export const ORDER_GET_DISCOUNT_AMOUNT = 'order/update/discount/amount';
export const ORDER_GET_DISCOUNT_APPLIED = 'order/update/appliedDiscount';
export const ORDER_GET_DISCOUNT_CODE_IS_APPLIED = 'order/update/discount/isApplied';
export const ORDER_GET_IS_DISCOUNT_DISABLED = 'order/update/discount/is-disabled';
export const ORDER_GET_DISCOUNT_PERCENT = 'order/update/discount/percent';
export const ORDER_GET_PAYMENT_LINE_ITEMS_COUNT = 'order/update/payment/lineItems/count';
export const ORDER_GET_PRODUCTS_LINE_ITEMS = 'order/update/products/lineItems';
export const ORDER_GET_PRODUCTS_PROGRESS = 'order/update/products/progress';
export const ORDER_GET_PRODUCTS_QUANTITY_COUNT = 'order/update/products/count';
export const ORDER_GET_PRODUCTS_SUBTOTAL = 'order/update/products/subtotal';
export const ORDER_GET_SHIPPING_ADDRESS = 'order/update/shipping/address';
export const ORDER_GET_SHIPPING_LINE = 'order/update/shipping/line';
export const ORDER_GET_SHIPPING_TOTAL_PRICE = 'order/update/shipping/total-price';
export const ORDER_GET_SHIPPING_DISCOUNTED_PRICE = 'order/update/shipping/discounted-price';
export const ORDER_GET_SHIPPING_ACTIVE_ZONE = 'order/update/shipping/active-zone';
